import React from "react";

function arrowRightSVG() {
  return (
    <svg
      width="24"
      height="32"
      viewBox="0 0 24 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask id="path-1-inside-1_593_44385" fill="white">
        <path d="M0 0H24V26C24 29.3137 21.3137 32 18 32H0V0Z" />
      </mask>
      <path d="M0 0H24V26C24 29.3137 21.3137 32 18 32H0V0Z" fill="#22FF91" />
      <path
        d="M0 0H24H0ZM25 26C25 29.866 21.866 33 18 33H-1L1 31H18C20.7614 31 23 28.7614 23 26H25ZM-1 33V0H1V31L-1 33ZM25 0V26C25 29.866 21.866 33 18 33V31C20.7614 31 23 28.7614 23 26V0H25Z"
        fill="#E3E3E3"
        mask="url(#path-1-inside-1_593_44385)"
      />
      <path
        d="M8.5 11.0671C9.4812 10.1836 10.9779 10.2069 11.9311 11.1206L16.1234 15.139C16.3288 15.3359 16.3288 15.6641 16.1234 15.861L11.9311 19.8794C10.9779 20.7931 9.4812 20.8164 8.5 19.9329V19.9329L12.82 15.5L8.5 11.0671Z"
        fill="#232323"
      />
    </svg>
  );
}

export default arrowRightSVG;
